import { useFilters } from "../useFilters";

/**
 * Hook spécifique pour gérer les filtres des customers
 * @param resetPageCallback - Fonction pour réinitialiser la pagination
 * @returns - Interface pour manipuler les filtres
 */
export function useCustomersFilters(resetPageCallback: () => void) {
  // Transformation des filtres pour l'affichage (aplatir les propriétés imbriquées)
  const transformForDisplay = (filters: Partial<EasyTech.CustomerFilterType>): Record<string, any> => {
    const displayFilters: Record<string, any> = {};

    if (filters.id) displayFilters.id = filters.id;
    if (filters.name) displayFilters.name = filters.name;
    if (filters.nip) displayFilters.nip = filters.nip;
    if (filters.externalId) displayFilters.externalId = filters.externalId;
    if (filters.odooNotSynced) displayFilters.odooNotSynced = filters.odooNotSynced;
    if (filters.type) displayFilters.type = filters.type;

    if (filters.contactInfo) {
      // La clé affichée est le chemin stocké : une puce `email` ne tombait sur
      // aucun champ, et le filtre restait après le clic sur la croix.
      if (filters.contactInfo.email) {
        displayFilters["contactInfo.email"] = filters.contactInfo.email;
      }
      if (filters.contactInfo.phone) {
        displayFilters["contactInfo.phone"] = filters.contactInfo.phone;
      }
    }

    return displayFilters;
  };

  // Récupération du hook générique avec transformation pour l'affichage
  return useFilters<EasyTech.CustomerFilterType>(
    resetPageCallback,
    {
      transformForDisplay
    }
  );
} 